import styled from "styled-components";

const AccordionStyled = styled.div`

  width: 100%;
  border-top: 1px solid #ccc;
  overflow: hidden;

.accordion-item {
  border-bottom: 1px solid #CFD0CF;
}


.accordion-heading {
    padding: 16px 0px;
  font-weight: 700;
  cursor: pointer;
  color: #008755;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 72px;
}

.iconWrapper {
    min-width: 14px;
    pointer-events: none;
}

.accordion-content {
  padding: 16px;
  font-weight: 400;
  line-height: 28px;
  background-color: #fff;
  transition: max-height 0.3s ease;
  gap: 24px;
  color: #000000;
}

`

export { AccordionStyled };
